import type { WsAudioEncoding } from "@storyboard/web-client";
import { store } from "@/store/store";
import type { AudioEncoding } from "@/store/types";

const transformWsAudioEncoding = (r: WsAudioEncoding): AudioEncoding => ({
  id: r.id,
  contentId: r.contentId,
  createdAt: r.createdAt ?? null,
  codec: r.codec,
  duration: r.duration.toString(),
  generatedService: r.generatedService ?? null,
  url: r.url,
  generatedVoice: r.generatedVoice ?? null,
  language: r.language ?? null,
  mimeType: r.mimeType ?? null,
  priority: r.priority ?? 0,
  transcriptionId: r.transcriptionId ?? null,
  transcriptionType: r.transcriptionType ?? null,
  translatedFrom: r.translatedFrom ?? null,
});

export async function bulkUpsertWsAudioEncodings(audioEncodingRecords: WsAudioEncoding[]) {
  if (audioEncodingRecords.length === 0) return;
  store.upsert("audioEncoding", audioEncodingRecords.map(transformWsAudioEncoding));
}
